// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimQuestion from '@deere/cps-it.warranty-model-factory/lib/claim-question';
import {FormattedMessage} from 'react-intl';
import SurveyQuestionsItem from './survey-questions-item';

function handleOptionChange(index, event) {

    this.actions.updateClaimQuestionChoice(index, event.target.value);

}

const SurveyQuestionsContainer = props =>
    <div className='survey-questions-container'>
        <h3>
            <FormattedMessage id='SURVEY_QUESTIONS'/>
        </h3>
        <div className='questions'>
            <ul>
                {
                    props.questions.map((question, index) =>
                        <SurveyQuestionsItem
                            isEditable={props.isEditable}
                            key={index}
                            onChange={handleOptionChange.bind(props, index)}
                            question={question}
                            questionsRequiredOptions={props.questionsRequiredOptions}
                        />
                    )
                }
            </ul>
        </div>
    </div>;

SurveyQuestionsContainer.displayName = 'SurveyQuestionsContainer';
SurveyQuestionsContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    questions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimQuestion)).isRequired,
    questionsRequiredOptions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimQuestion)).isRequired
};

export default SurveyQuestionsContainer;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/components/survey-questions/survey-questions-container.js